import request from '@/utils/request'

// 获取人脸链接
export function get_face_url(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/phone/get_face_url',
    method: 'post',
    data
  })
}

// 人脸验证并修改绑定手机号
export function modify_by_face(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/phone/modify_by_face',
    method: 'post',
    data
  })
}

// PC端重新获取人脸链接
export function retrieve_face_url() {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/phone/retrieve_face_url',
    method: 'post'
  })
}
